var _defs, _g, _polygon, _g2, _polygon2, _g3, _polygon3, _g4, _polygon4, _g5, _rect, _path, _path2, _polygon5, _polygon6, _polygon7, _polygon8, _g6, _g7, _rect2, _rect3, _rect4, _rect5, _path3, _rect6, _g8, _circle, _circle2, _circle3, _circle4, _path4, _path5, _path6, _path7, _path8, _g9, _circle5, _g0, _circle6, _g1, _circle7, _g10, _path9, _path0, _circle8, _circle9, _path1, _path10, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _circle14, _g11, _path11, _path12, _circle15, _circle16, _path13, _path14, _g12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "61f8f3fd-6b56-45c5-89f2-afa0c413a7fa",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 925.18,
    height: 770.09,
    viewBox: "0 0 925.18 770.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2b43956-505e-42fa-8271-42f9f0912862",
    x1: 580.55,
    y1: 759,
    x2: 580.55,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd",
    x1: 345.9,
    y1: 617.2,
    x2: 345.9,
    y2: 679.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fccc63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f55f44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f0b6c0c1-af46-47f0-89cc-f1295e85d837",
    x1: 420.89,
    y1: 617.2,
    x2: 420.89,
    y2: 679.83,
    xlinkHref: "#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "835adc3d-9947-42f8-a8c1-90fc1375c35f",
    x1: 467.86,
    y1: 617.2,
    x2: 467.86,
    y2: 679.83,
    xlinkHref: "#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "05d2e404-cee9-4ec4-9322-f8806c9b5d69",
    x1: 543.67,
    y1: 617.2,
    x2: 543.67,
    y2: 679.83,
    xlinkHref: "#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "84020695-8aca-4fdc-a56d-10a85085e734",
    x1: 580.55,
    y1: 835.05,
    x2: 580.55,
    y2: 647.79,
    xlinkHref: "#f2b43956-505e-42fa-8271-42f9f0912862"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee8b87cd-bc8a-4975-b833-23268ebbebf9",
    x1: 272.71,
    y1: 586.52,
    x2: 272.71,
    y2: 732.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "93e0219e-fb1a-4fd7-ab06-cb9d2e8d46b6",
    x1: 272.35,
    y1: 606.91,
    x2: 272.35,
    y2: 766.41,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eaf709e1-10fa-49af-93d3-e446f8f22d21",
    x1: 596.45,
    y1: 606.91,
    x2: 596.45,
    y2: 766.41,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b99db109-4c8d-4947-bfd9-8341738d16d4",
    x1: 592.44,
    y1: 620.75,
    x2: 592.44,
    y2: 766.41,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "73d53186-09ce-4d56-8d1f-5ffca19f900f",
    x1: 574.72,
    y1: 699.54,
    x2: 574.72,
    y2: 831.37,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1bd4c24-bb4d-4277-a1fb-6bc8d7a55dfd",
    x1: 482.23,
    y1: 737.41,
    x2: 482.23,
    y2: 831.37,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "319244db-d860-4fad-863b-9a3a16f5944b",
    x1: 665.03,
    y1: 751.98,
    x2: 665.03,
    y2: 831.37,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3a40aa9d-8c97-4785-a2ce-02f5c84266af",
    x1: 802.69,
    y1: 737.41,
    x2: 802.69,
    y2: 831.37,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f3ea85b0-d529-430f-a5f3-7431de71f741",
    x1: 358.41,
    y1: 737.41,
    x2: 358.41,
    y2: 831.37,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "421cecf6-ea42-4f8e-95af-7dadfc0b5864",
    x1: 710.43,
    y1: 616.63,
    x2: 710.43,
    y2: 589.91,
    xlinkHref: "#f2b43956-505e-42fa-8271-42f9f0912862"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b76e450b-11c8-416c-a0eb-ba73061d2446",
    x1: 710.43,
    y1: 590.89,
    x2: 710.43,
    y2: 615.65,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "72df51fc-e37e-4ea5-a672-fa692e8e4323",
    x1: 771.61,
    y1: 746.75,
    x2: 771.61,
    y2: 717.62,
    xlinkHref: "#f2b43956-505e-42fa-8271-42f9f0912862"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7c061988-e8ee-45a9-b1b1-05af47469914",
    x1: 771.61,
    y1: 718.34,
    x2: 771.61,
    y2: 746.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0922416-7296-47ba-816d-5ff33eb958ea",
    x1: 148.17,
    y1: 665.16,
    x2: 148.17,
    y2: 633.14,
    xlinkHref: "#f2b43956-505e-42fa-8271-42f9f0912862"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "63e85972-a6d1-4957-b932-816027d688a4",
    x1: 148.17,
    y1: 633.86,
    x2: 148.17,
    y2: 664.45,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "299d5e2e-be3b-4509-84b8-ec33c3786422",
    x1: 853.67,
    y1: 152.79,
    x2: 853.67,
    y2: 64.95,
    xlinkHref: "#f2b43956-505e-42fa-8271-42f9f0912862"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f866518d-8775-4843-b285-e9e24a2ef8da",
    x1: 771.61,
    y1: 718.34,
    x2: 771.61,
    y2: 746.02,
    xlinkHref: "#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "20e3e192-3217-42d5-9266-898a1edf98f2",
    x1: 389.67,
    y1: 446.79,
    x2: 389.67,
    y2: 404.95,
    xlinkHref: "#f2b43956-505e-42fa-8271-42f9f0912862"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "To the stars") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722,411.58a150.57,150.57,0,0,0-17-70c-5.34-10.15-10.21-16.46-14-20.33A10,10,0,0,0,679.6,319a10.28,10.28,0,0,0-4,2.58c-5.07,5.25-9.65,12.19-13.65,19.58a151.15,151.15,0,0,0-17.87,71.92v15.06h-9.66v-175c0-36.68-8.21-72.87-24.29-105-7.62-15.21-14.57-24.66-19.92-30.47a13.81,13.81,0,0,0-20.76,0c-7.24,7.87-13.77,18.27-19.48,29.33-16.91,32.79-25.5,70-25.5,107.77V428.14h-8.35V412.36a151.15,151.15,0,0,0-17.87-71.92c-4-7.38-8.58-14.32-13.65-19.58A10,10,0,0,0,473,318.74l.35.19a10.31,10.31,0,0,0-3.26,2.28c-3.75,3.87-8.62,10.18-14,20.33a150.57,150.57,0,0,0-17,70V673.18h29.8l-3.25,21.51V759H490V694.69l-3.25-21.51h29.37V434.91h8.35v237.2h23.8l-3.42,22.57V759h24.37V694.69l-3.42-22.57h32.07l-3.42,22.57V759h24.37V694.69l-3.42-22.57h19V434.91h9.66V673.54h7.83v-.36h25.89l-3.25,21.51V759h24.37V694.69l-3.25-21.51H722Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#f2b43956-505e-42fa-8271-42f9f0912862)"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "357.44 617.2 334.37 617.2 338.49 589.19 353.32 589.19 357.44 617.2",
    fill: "#535461"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.34 600.31 354.47 600.31 353.32 592.48 338.49 592.48 337.34 600.31"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.2 617.2 532.13 617.2 536.25 589.19 551.08 589.19 555.2 617.2",
    fill: "#535461"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "535.1 600.31 552.23 600.31 551.08 592.48 536.25 592.48 535.1 600.31"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.43 617.2 409.35 617.2 413.47 589.19 428.31 589.19 432.43 617.2",
    fill: "#535461"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "412.32 600.31 429.46 600.31 428.31 592.48 413.47 592.48 412.32 600.31"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.39 617.2 456.32 617.2 460.44 589.19 475.27 589.19 479.39 617.2",
    fill: "#535461"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "459.29 600.31 476.43 600.31 475.27 592.48 460.44 592.48 459.29 600.31"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 357.44,
    y: 357.64,
    width: 164.8,
    height: 6.59,
    fill: "#535461"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M685.13,318.46a9.29,9.29,0,0,0-13.77,0c-4.8,5.11-9.13,11.87-12.92,19.06a150.58,150.58,0,0,0-16.91,70V661.21h72.93V406.47a150,150,0,0,0-16.11-68.21C693.29,328.38,688.68,322.23,685.13,318.46Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#e0e0e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476,318.46a9.29,9.29,0,0,1,13.77,0c4.8,5.11,9.13,11.87,12.92,19.06a150.58,150.58,0,0,1,16.91,70V661.21H446.65V406.47a150,150,0,0,1,16.11-68.21C467.81,328.38,472.42,322.23,476,318.46Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#e0e0e0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "309.65 346.93 326.95 347.01 326.95 368.35 309.65 368.35 309.65 346.93",
    fill: "#535461"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "364.86 346.93 382.16 347.01 382.16 368.35 364.86 368.35 364.86 346.93",
    fill: "#535461"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "504.11 346.93 521.42 347.01 521.42 368.35 504.11 368.35 504.11 346.93",
    fill: "#535461"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "559.32 346.93 576.63 347.01 576.63 368.35 559.32 368.35 559.32 346.93",
    fill: "#535461"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.66,337.19c-3.78-7.19-8.12-13.95-12.92-19.06a9.26,9.26,0,0,0-11-2.07,9.83,9.83,0,0,1,2.78,2.07c4.8,5.11,9.13,11.87,12.92,19.06a150.58,150.58,0,0,1,16.91,70V660.86h8.24V407.22A150.58,150.58,0,0,0,502.66,337.19Z",
    transform: "translate(-137.41 -64.95)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665,337.89c3.78-7.19,8.12-13.95,12.92-19.06a9.8,9.8,0,0,1,3.19-2.28,9.27,9.27,0,0,0-10.6,2.28c-4.8,5.11-9.13,11.87-12.92,19.06a150.58,150.58,0,0,0-16.91,70V661.56h7.42V407.93A150.58,150.58,0,0,1,665,337.89Z",
    transform: "translate(-137.41 -64.95)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 334.37,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    fill: "url(#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 409.35,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    fill: "url(#f0b6c0c1-af46-47f0-89cc-f1295e85d837)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 456.32,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    fill: "url(#835adc3d-9947-42f8-a8c1-90fc1375c35f)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 532.13,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    fill: "url(#05d2e404-cee9-4ec4-9322-f8806c9b5d69)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M589.7,119.56a12.84,12.84,0,0,0-19.65,0c-6.85,7.66-13,17.79-18.44,28.57-16,31.94-24.14,68.19-24.14,104.95V660.17H631.56V251.44c0-35.72-7.77-71-23-102.21C601.35,134.42,594.77,125.22,589.7,119.56Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#eee"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 414.23,
    y: 99.83,
    width: 54.31,
    height: 24.89,
    rx: 11,
    ry: 11,
    fill: "#1db9cc"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822,737.93h0A83,83,0,0,0,657.12,752c0,.41,0,.81,0,1.22h0a76.61,76.61,0,0,0-9.1,1.95,75.84,75.84,0,0,0-142.6-12.91,75,75,0,0,0-20.92-4.78h0a82.38,82.38,0,0,0-5.71-18.85,75.8,75.8,0,0,0-151.12-2A82.45,82.45,0,0,0,320.25,743h0a75.88,75.88,0,0,0-43.49,92H884.34A75.86,75.86,0,0,0,822,737.93Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#84020695-8aca-4fdc-a56d-10a85085e734)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 272.71,
    cy: 659.35,
    r: 72.83,
    fill: "url(#ee8b87cd-bc8a-4975-b833-23268ebbebf9)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.35,
    cy: 686.66,
    r: 79.75,
    fill: "url(#93e0219e-fb1a-4fd7-ab06-cb9d2e8d46b6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.45,
    cy: 686.66,
    r: 79.75,
    fill: "url(#eaf709e1-10fa-49af-93d3-e446f8f22d21)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.44,
    cy: 693.58,
    r: 72.83,
    fill: "url(#b99db109-4c8d-4947-bfd9-8341738d16d4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M647.55,772.37a72.7,72.7,0,0,1-30.12,59H532a72.86,72.86,0,1,1,115.54-59Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#73d53186-09ce-4d56-8d1f-5ffca19f900f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M555.06,810.24a72.5,72.5,0,0,1-3.12,21.12H412.51a0,0,0,0,1,0-.05,72.83,72.83,0,0,1,69.28-93.9h.45q3.06,0,6.07.25a72.07,72.07,0,0,1,20.09,4.59A72.85,72.85,0,0,1,555.06,810.24Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#f1bd4c24-bb4d-4277-a1fb-6bc8d7a55dfd)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M737.87,824.81q0,3.27-.29,6.47a.18.18,0,0,1,0,.09H592.5c-.2-2.16-.3-4.35-.3-6.55a72.76,72.76,0,0,1,61.92-72A73.77,73.77,0,0,1,665,752c1.86,0,3.71.07,5.54.2a72.89,72.89,0,0,1,60.9,42.74c.3.66.59,1.33.86,2A72.48,72.48,0,0,1,737.87,824.81Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#319244db-d860-4fad-863b-9a3a16f5944b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M875.52,810.24a72.5,72.5,0,0,1-3.12,21.12H733s0,0,0,0a73.29,73.29,0,0,1-1.87-34.54c.12-.63.24-1.27.38-1.89a72.86,72.86,0,0,1,71.22-57.51c2.29,0,4.54.1,6.77.32,1,.08,2,.2,3,.33A72.84,72.84,0,0,1,875.52,810.24Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#3a40aa9d-8c97-4785-a2ce-02f5c84266af)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M428.13,831.37c.24-.76.45-1.52.66-2.29A72.88,72.88,0,0,0,339,740a69.46,69.46,0,0,0-8.51,2.94,72.9,72.9,0,0,0-41.78,88.4H428.13Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#f3ea85b0-d529-430f-a5f3-7431de71f741)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 710.43,
    cy: 603.27,
    r: 13.36,
    fill: "url(#421cecf6-ea42-4f8e-95af-7dadfc0b5864)"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 710.43,
    cy: 603.27,
    r: 12.38,
    fill: "url(#b76e450b-11c8-416c-a0eb-ba73061d2446)"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 771.61,
    cy: 732.18,
    r: 14.57,
    fill: "url(#72df51fc-e37e-4ea5-a672-fa692e8e4323)"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.61,
    cy: 732.18,
    r: 13.84,
    fill: "url(#7c061988-e8ee-45a9-b1b1-05af47469914)"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.17,
    cy: 649.15,
    r: 16.01,
    fill: "url(#a0922416-7296-47ba-816d-5ff33eb958ea)"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.17,
    cy: 649.15,
    r: 15.29,
    fill: "url(#63e85972-a6d1-4957-b932-816027d688a4)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M888.73,82.42h0a44.33,44.33,0,0,0-13.08-11.58h0a43.92,43.92,0,1,0-22,82c.93,0,1.86,0,2.78-.09a43.91,43.91,0,0,0,32.28-70.28Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#299d5e2e-be3b-4509-84b8-ec33c3786422)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M895.18,108.87A41.51,41.51,0,0,1,856.3,150.3c-.87.06-1.75.09-2.63.09a41.51,41.51,0,1,1,20.76-77.47h0a41.9,41.9,0,0,1,12.37,10.95h0A41.3,41.3,0,0,1,895.18,108.87Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#1db9cc",
    opacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M843.45,82.54a45.19,45.19,0,0,0-6.19,3.26,9.8,9.8,0,0,0-3.31,3,3.9,3.9,0,0,0-.08,4.23c1,1.38,3,1.6,4.67,1.69a8.86,8.86,0,0,0,8.48-2.8l3.57-3.24c1.24-1.12,2.6-2.67,2.06-4.25-.41-1.21-1.77-1.8-3-2a12.59,12.59,0,0,0-8.93,1.57",
    transform: "translate(-137.41 -64.95)",
    fill: "#f55f44",
    opacity: 0.05
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 691.13,
    cy: 60.31,
    r: 2.18,
    fill: "#f55f44",
    opacity: 0.05
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.56,
    cy: 46.47,
    r: 8.01,
    fill: "#f55f44",
    opacity: 0.05
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M886.81,83.86h0a10.93,10.93,0,1,1-12.37-11h0A41.9,41.9,0,0,1,886.81,83.86Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#f55f44",
    opacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M887.61,132.78A41.41,41.41,0,0,1,856.3,150.3c-.05-.57-.08-1.15-.08-1.73a19.67,19.67,0,0,1,31.39-15.79Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#f55f44",
    opacity: 0.05
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.81,
    cy: 344.72,
    r: 5.1,
    fill: "#535461",
    opacity: 0.25
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.81,
    cy: 478.72,
    r: 5.1,
    fill: "#535461",
    opacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 919.81,
    cy: 507.72,
    r: 5.1,
    fill: "#535461",
    opacity: 0.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.73,
    cy: 266.06,
    r: 5.1,
    fill: "#535461",
    opacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.98,
    cy: 148.8,
    r: 5.1,
    fill: "#535461",
    opacity: 0.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.77,
    cy: 381.13,
    r: 5.1,
    fill: "#535461",
    opacity: 0.25
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "849.18 387.12 844.64 387.12 844.64 382.59 842.79 382.59 842.79 387.12 838.25 387.12 838.25 388.98 842.79 388.98 842.79 393.51 844.64 393.51 844.64 388.98 849.18 388.98 849.18 387.12",
    fill: "#535461",
    opacity: 0.25
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "925.18 230.12 920.64 230.12 920.64 225.59 918.79 225.59 918.79 230.12 914.25 230.12 914.25 231.98 918.79 231.98 918.79 236.51 920.64 236.51 920.64 231.98 925.18 231.98 925.18 230.12",
    fill: "#535461",
    opacity: 0.25
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "601.55 142.41 597.01 142.41 597.01 137.87 595.16 137.87 595.16 142.41 590.62 142.41 590.62 144.26 595.16 144.26 595.16 148.8 597.01 148.8 597.01 144.26 601.55 144.26 601.55 142.41",
    fill: "#535461",
    opacity: 0.25
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "799.65 361.63 795.11 361.63 795.11 357.1 793.26 357.1 793.26 361.63 788.73 361.63 788.73 363.49 793.26 363.49 793.26 368.02 795.11 368.02 795.11 363.49 799.65 363.49 799.65 361.63",
    fill: "#535461",
    opacity: 0.25
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "633.59 512.39 629.06 512.39 629.06 507.86 627.21 507.86 627.21 512.39 622.67 512.39 622.67 514.25 627.21 514.25 627.21 518.78 629.06 518.78 629.06 514.25 633.59 514.25 633.59 512.39",
    fill: "#535461",
    opacity: 0.25
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.93 201.4 164.39 201.4 164.39 196.87 162.54 196.87 162.54 201.4 158 201.4 158 203.25 162.54 203.25 162.54 207.79 164.39 207.79 164.39 203.25 168.93 203.25 168.93 201.4",
    fill: "#535461",
    opacity: 0.25
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.93 260.4 6.39 260.4 6.39 255.87 4.54 255.87 4.54 260.4 0 260.4 0 262.25 4.54 262.25 4.54 266.79 6.39 266.79 6.39 262.25 10.93 262.25 10.93 260.4",
    fill: "#535461",
    opacity: 0.25
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.56 446.12 227.02 446.12 227.02 441.58 225.17 441.58 225.17 446.12 220.64 446.12 220.64 447.97 225.17 447.97 225.17 452.51 227.02 452.51 227.02 447.97 231.56 447.97 231.56 446.12",
    fill: "#535461",
    opacity: 0.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.61,
    cy: 732.18,
    r: 13.84,
    fill: "url(#f866518d-8775-4843-b285-e9e24a2ef8da)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.37,413.27h0a21.11,21.11,0,0,0-6.23-5.52h0a20.92,20.92,0,1,0-10.46,39c.44,0,.89,0,1.32,0a20.92,20.92,0,0,0,15.37-33.47Z",
    transform: "translate(-137.41 -64.95)",
    fill: "url(#20e3e192-3217-42d5-9266-898a1edf98f2)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M409.44,425.87a19.77,19.77,0,0,1-18.52,19.73c-.41,0-.83,0-1.25,0a19.77,19.77,0,1,1,9.89-36.9h0a20,20,0,0,1,5.89,5.21h0A19.67,19.67,0,0,1,409.44,425.87Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#1db9cc",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M384.8,413.33a21.52,21.52,0,0,0-3,1.55,4.67,4.67,0,0,0-1.58,1.41,1.86,1.86,0,0,0,0,2,2.83,2.83,0,0,0,2.22.8,4.22,4.22,0,0,0,4-1.33l1.7-1.54c.59-.54,1.24-1.27,1-2a1.79,1.79,0,0,0-1.44-1,6,6,0,0,0-4.25.75",
    transform: "translate(-137.41 -64.95)",
    fill: "#f55f44",
    opacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.29,
    cy: 368.72,
    r: 1.04,
    fill: "#f55f44",
    opacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.45,
    cy: 362.13,
    r: 3.82,
    fill: "#f55f44",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M405.45,414h0a5.2,5.2,0,1,1-5.89-5.22h0A20,20,0,0,1,405.45,414Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#f55f44",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M405.84,437.26a19.72,19.72,0,0,1-14.91,8.35c0-.27,0-.55,0-.83a9.37,9.37,0,0,1,15-7.52Z",
    transform: "translate(-137.41 -64.95)",
    fill: "#f55f44",
    opacity: 0.1
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.59,
    y: 202.05,
    width: 103,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketTeal);
export default __webpack_public_path__ + "static/media/rocketTeal.65ea0f9b45e1e2b70bb2a08a495dd2db.svg";
export { ForwardRef as ReactComponent };